const prefix = '@@CAMPAIGN_CALENDAR';

export const REQUEST_INITIAL_DATA = `${prefix}__REQUEST_INITIAL_DATA`;
export const UPDATE_DATA = `${prefix}__UPDATE_DATA`;
export const SET_DATA = `${prefix}__SET_DATA`;
export const SET_ERROR = `${prefix}__SET_ERROR`;
